import * as React from "react";

export interface IArrowFocusableProps {
    className?: string;
    disabled: boolean;
    children?: React.ReactNode;
    component?: string;
    focusableSelector?: string;
}

export class ArrowFocusable extends React.Component<IArrowFocusableProps, any> {
    container = React.createRef<HTMLDivElement>();
    
    handleArrowKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (!this.props.disabled) {
            if(event.key === 'ArrowDown' || event.key === 'ArrowRight') {
                this.moveFocusDown()
            }
            if(event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
                this.moveFocusUp()
            }
        }
    };

    moveFocusDown() {
        const query = this.container.current?.querySelectorAll(this.props.focusableSelector || '.focusable');
        const iterableItems = query || [];
        const listItems = [...iterableItems];
        const activeItem = document.activeElement;
        const activeItemIndex = listItems.indexOf(activeItem);
        if (listItems.length) {
            if (activeItemIndex >= 0) {
                if (activeItemIndex < listItems.length - 1) {
                    listItems[activeItemIndex+1].focus();
                    return
                }                
            }
            const item = listItems[0] as HTMLElement;
            item.focus();
            item.scrollIntoView({ behavior: "smooth", block:"start" });
        }
    }
    
    moveFocusUp() {
        const query = this.container.current?.querySelectorAll(this.props.focusableSelector || '.focusable');
        const iterableItems = query || [];
        const listItems = [...iterableItems];
        const activeItem = document.activeElement;
        const activeItemIndex = listItems.indexOf(activeItem);
        if (listItems.length) {
            if (activeItemIndex >= 0) {
                if (activeItemIndex > 0) {
                    listItems[activeItemIndex-1].focus();
                    return
                }
            }
            const item = listItems[listItems.length - 1] as HTMLElement;
            item.focus();
            item.scrollIntoView({ behavior: "smooth", block:"start"});
        }
    }

    render() {
        return React.createElement(this.props.component || "div", {
            ref: this.container,
            className: this.props.className,
            onKeyDown: this.handleArrowKeyDown,
            children: this.props.children
        });
    }
}